import { CONSTANTS } from '../../constants';
import { parse } from 'querystring'; //  FIXME: rename LOGGER.QUERY_NAME to DEBUG.QUERY_NAME
// FIXME: add comments

export var debugEnabled = function debugEnabled() {
  return parse(window.location.search)[CONSTANTS.LOGGER.QUERY_NAME] === '1' || process.env.NODE_ENV === 'development';
};